import { ApoQueryable } from '../modules/apo/models/apoRecord.model';
import { NoticeConditionModel } from '../modules/apo/models/NoticeConditionModel.model';
import { ParcelInfoModel } from './parcelInfoModel.model';
import { TemplateAttributeModel } from './templateattributemodel.model';

export class OwnerModel  implements ApoQueryable {
        /// <remarks/>
        address: string;

        /// <remarks/>
        address1: string;

        /// <remarks/>
        address2: string;

        /// <remarks/>
        address3: string;

        /// <remarks/>
        auditDate: Date;

        /// <remarks/>
        auditID: string;

        /// <remarks/>
        auditStatus: string;

        /// <remarks/>
        city: string;

        /// <remarks/>
        country: string;

        /// <remarks/>
        //public DuplicatedAPOKeyModel[] duplicatedAPOKeys

        /// <remarks/>
        email: string;

        /// <remarks/>
        eventID: number;

        /// <remarks/>
        fax: string;

        /// <remarks/>
        faxCountryCode: string;

        /// <remarks/>
        /// Highest Notice placed on Record
        /// </remarks>
        hightestCondition: NoticeConditionModel;

        /// <remarks/>
        /// Notices placed on Record
        /// </remarks>
        noticeConditions: NoticeConditionModel[];

        /// <remarks/>
        isPrimary: string;

        /// <remarks/>
        ivrPinNumber: string;

        /// <remarks/>
        ivrUserNumber: string;

        /// <remarks/>
        mailFullName: string;

        /// <remarks/>
        mailAddress1: string;

        /// <remarks/>
        mailAddress2: string;

        /// <remarks/>
        mailAddress3: string;

        /// <remarks/>
        mailCity: string;

        /// <remarks/>
        mailCountry: string;

        /// <remarks/>
        mailState: string;

        /// <remarks/>
        mailZip: string;

        /// <remarks/>
        mappingDailyOwnerNbr: string;

        /// <remarks/>
        //public NoticeConditionModel[] noticeConditions

        /// <remarks/>
        ownerFirstName: string;

        /// <remarks/>
        ownerFullName: string;

        /// <remarks/>
        ownerLastName: string;

        /// <remarks/>
        ownerMiddleName: string;

        /// <remarks/>
        ownerNumber: number;

        /// <remarks/>
        ownerStatus: string;

        /// <remarks/>
        ownerTitle: string;

        /// <remarks/>
        parcelLists: Array<ParcelInfoModel>;

        /// <remarks/>
        phone: string;

        /// <remarks/>
        phoneCountryCode: string;

        /// <remarks/>
        resCountry: string;

        /// <remarks/>
        sourceSeqNumber: number;

        /// <remarks/>
        state: string;

        /// <remarks/>
        taxID: string;

        /// <remarks/>
        templates: Array<TemplateAttributeModel>;

        /// <remarks/>
        UID: string;

        /// <remarks/>
        zip: string;
}
